<template>
    <div class="sendNoticeVue">
    <!-- Main Body Content area -->
        <div class="o-main-content-area o-main-content-area--padBotoomNone">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <!-- <div class="col-md-6">
                    <h1 class="h1">Add Employee:</h1>
                </div>
                <div class="col-md-6 text-right">
                    <ul class="o-filter-area">
                        <li><a @click="submitNewEmployee()" class="c-common-btn c-common-btn--large c-common-btn--green">  <i class="fa fa-plus" aria-hidden="true"></i>Submit new employee </a></li>
                    </ul>
                </div> -->
                <div class="col-sm-12">
                    <div class="text-center">
                        <ul class="o-filter-area notic-ul-item">
                            <li class="notic-li-item">
                                <span class="req-text">* </span>
                                <span>
                                    Employee accounts are managed by Call Steward, although as a client, you control the access that Employee is granted.
                                </span>
                            </li>
                            <br />
                            <li class="notic-li-item">
                                <span class="req-text">* </span>
                                <span>
                                    Before you add an Employee to your own list, please do a search to avoid duplicate entries.
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
            <div class="row c-responsive-fixwidth"  v-if="step1 || step2">
                <div class="col-md-12">
                    <h1 class="h1 text-center">Check Employee Availability </h1>
                </div>
            </div>
        </div>
        <div class="o-ndividualArea c-responsive-fixwidth" v-loading="loading">
            <div class="col-md-6 col-md-offset-3">
                <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white" v-if="step1 || step2">
                    <div v-loading="loading" class="row">
                        <div class="col-sm-12"> 
                        
                            <div v-if="step1">
                                 <!-- <div class="o-super-client-area c-radius3 u-bg-white"> -->
                                    <label class="common-label-text o-super-label">Enter Email:</label>
                                    <!-- <div class="row"> -->
                                        <!-- <div class="col-sm-8">
                                            <div class="form-group ">
                                                <label class="common-label-text o-super-label">Enter Email:</label>
                                                <input autocomplete="off" class="form-group form-control" @input="checkClientEmployeeList()" type="email" name="email" placeholder="Email" v-model="employeeExistEmail">

                                            </div>
                                        </div> -->
                                        <!-- <div class="col-sm-4">
                                            <div class="text-center">
                                                <ul class="o-filter-area">
                                                    <li>
                                                        <a href="javascript: void(0)" @click="checkClientEmployeeList()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-paper-plane" aria-hidden="true"></i> Check</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div> -->
                                        <!-- <p v-if="emailStatus&&emailStatus != ''">{{ emailStatus }}</p> -->
                                    <!-- </div> -->
                                    <!-- <div>
                                        <p v-if="emailStatusMessage != ''">
                                            <span :class="emailStatus?'email-status-success':'email-status-error'">{{ emailStatusMessage+':' }} </span>
                                            <span v-if="emailStatus">Email not registered. Please
                                                <a href="javascript: void(0)" @click="openStep3()" class="c-solid-btn c-solid-btn--large c-solid-btn--green">Register</a>
                                            </span>
                                        </p>    
                                        <br v-if="emailStatusMessage !=''" />                                 
                                    </div>                                                     -->
                                <!-- </div>  -->
                                <!-- <div class="pl-20">  
                                    OR
                                </div>                              -->
                                <!-- STEP - 1  -->
                                <div class="o-super-client-area c-radius3 u-bg-white">   
                                    <div class="row">
                                        <div class="col-sm-8">
                                            <input type="text" placeholder="Email" class="form-group form-control" id="employee-search-input" autofocus="true" v-model="internalEmployeeSearch"  @input="checkClientEmployeeList()" />
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="text-center">
                                                <ul class="o-filter-area">
                                                    <li>
                                                        <a href="javascript: void(0)" @click="checkClientEmployeeListOnClick()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-paper-plane" aria-hidden="true"></i> Check</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            </div>

                            <div class="o-ndividualArea" v-if="checkEmployeeList">
                                <strong class="pl-20 pb-6" v-if="employeesList.length&&internalEmployeeSearch.length">Employee(s) Already Associated({{ employeesList.length }})</strong>
                                <div class="o-super-client-area c-radius3 u-bg-white" v-if="employeesList&&employeesList.length&&internalEmployeeSearch.length">
                                    <div class="custom-list-search-background">
                                        <table class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 payroll-viewcall-table-align overflow-show">
                                            <thead>
                                                <tr>
                                                    <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10">
                                                        <span class="o-no-margin-bottom">S.No:</span>
                                                    </th>
                                                    <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">Name:</span></th>
                                                    <th align="left" valign="top" class="o-accordion-subtext u-cmn-padding10"><span class="o-no-margin-bottom">Email</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(employeeObj, index) in employeesList" :key="index" class="custom-list-search">
                                                    <td align="left" valign="top" class="o-rowtable-text table-td-border-top u-cmn-padding5">
                                                        <p>{{ index+1 }}</p>
                                                    </td>
                                                    <td align="left" valign="top" class="o-rowtable-text table-td-border-top u-cmn-padding5">
                                                        <p>{{ employeeObj.employable?(employeeObj.employable.first_name + ' ' +  employeeObj.employable.last_name):''}}</p>
                                                    </td>
                                                    <td align="left" valign="top" class="o-rowtable-text table-td-border-top u-cmn-padding5">
                                                        <p>{{ employeeObj.employable?employeeObj.employable.email:'' }}</p>
                                                    </td>   
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div v-else-if="internalEmployeeSearch.length" class="o-super-client-area u-bg-white" >
                                    No Employees Found
                                </div>
                                <br />
                                <br />
                                <div class="text-center">
                                    <ul class="o-filter-area">
                                        <li>
                                            <a href="javascript: void(0)" @click="cancelAddEmployeeProcess()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                        </li>
                                        <li>
                                            <a href="javascript: void(0)" @click="addExternalEmployee()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add External Employee</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="o-ndividualArea" v-if="step2">
                                STEP - 2 <br /><br />
                                <div class="o-super-client-area c-radius3 u-bg-white">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <div class="form-group ">
                                                <label class="common-label-text o-super-label">Search Employee:</label>
                                                <input autocomplete="off" type="text" v-model="search_query" v-on:keyup="searchExternalEmployees()" class="form-control" placeholder="Search Email">
                                            </div>
                                        </div>
                                    </div>
                                    <div v-loading="loading" v-if="search_query" class="custom-list-search-background">
                                        <div v-for="(employee, inx) in addEmployeesList" class="row custom-list-search" :key="inx">
                                            <div class="col-sm-4 o-accordion-subtext o-rowtable-text">
                                                <div>{{employee.first_name+' '+employee.last_name}}</div>
                                            </div>
                                            <div class="col-sm-5">
                                                <div>{{employee.email}}</div>
                                                
                                            </div>
                                            <div class="col-sm-3" style="text-align: right;">
                                                <a href="javascript: void(0)" @click="addEmployee(employee)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i>Add</a>
                                            </div>
                                        </div>
                                        <div v-if="addEmployeesList.length==0 && apires" class="row">
                                            <div class="col-sm-12" style="text-align: center;">
                                                <div>Employee Not Found</div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <br />
                                <br />

                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="text-center">
                                            <ul class="o-filter-area">
                                                <li>
                                                    <a href="javascript: void(0)" @click="cancelAddEmployeeProcess()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                                </li>
                                                <li>
                                                    <a href="javascript: void(0)" @click="openStep3()" :disabled="!selectedEmployeeId.length" class="c-solid-btn c-solid-btn--large c-solid-btn--orange"><i class="fa fa-plus" aria-hidden="true"></i> My Employee is Not Listed - Create New Employee</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                            
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="step3">
                    <div class="row c-responsive-fixwidth">
                        <div class="col-md-12">
                            <h1 class="h1 text-center">Add New Employee</h1>
                        </div>
                    </div>
                    <div class="c-common-box-shadow o-super-client-area c-radius3 u-bg-white">
                        <div class="field-group">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="c-common-space c-responsive-fixwidth c-radius3 c-user-tab-content clearfix o-skillset-area">
                                    <div class="col-sm-12 no_padding">
                                        <p>Basic Info:</p>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group ">
                                                    <label class="common-label-text form-label">First Name:<sup class="req-text">*</sup></label>
                                                    <input v-model="employee.first_name" @blur="blur($event)" v-validate="'required'" name="first name" type="text" class="form-control" placeholder="Name">
                                                    <span class="err-msg">**REQUIRED FIELD**</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="form-group ">
                                                    <label class="common-label-text form-label">Last Name:<sup class="req-text">*</sup></label>
                                                    <input v-model="employee.last_name" v-validate="'required'" @blur="blur($event)" name="Contact Person" type="text" class="form-control" placeholder="Name">
                                                    <span class="err-msg">**REQUIRED FIELD**</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <label class="common-label-text form-label">Email:<sup  class="req-text">*</sup></label>
                                                    <input v-on:keyup="emailExists()" v-model="employee.email" v-validate="'required|email'" @blur="blur($event)" name="email" type="text" class="form-control" placeholder="Email">
                                                    <span class="err-msg" v-if="!email_status && !(errors.has('email'))">Email already exists.</span>
                                                    <span v-if="!errors.has('email') && email_status" class="err-msg">**REQUIRED FIELD**</span>
                                                    <span v-else class="err-msg">{{ errors.first('email') }}</span>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <label class="common-label-text form-label">Cell Phone:<sup class="req-text">*</sup></label>

                                                    <input v-model="employee.cell_phone" v-validate="'required|min:10|max:15'" @blur="blurCellPhone($event)" type="tel" class="form-control" placeholder="Cell Phone" name="cellPhone" data-vv-delay="500">
                                                    <span v-if="errors.has('cellPhone')" class="err-msg">Cell Phone is required, Must have minimum length of 10</span>
                                                    <span v-else class="err-msg">**REQUIRED FIELD**  10 - 15 digits- Exclude all Dots, Spaces and Dashes. </span>
                                                </div>
                                            </div>
                                        </div>

                                        <br />
                                        <br />

                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="text-center">
                                                    <ul class="o-filter-area">
                                                        <li>
                                                            <a href="javascript: void(0)" @click="cancelAddEmployeeProcess()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                                        </li>
                                                        <li>
                                                            <a href="javascript: void(0)" @click="saveNewEmployee()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save" aria-hidden="true"></i> Save</a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {bus} from '../../main';
    import {mapGetters, mapActions} from 'vuex';
    import service from '../../services.js';
    let timeout = null;

    export default {
      data() {
          return { 
            addEmployeesList:[],
            filteredOptions: [],
            selectedEmployeeId:[],
            selectedStatusId:'all',
            selectedSortType:'asc',
            selectedEmployeePattern: '',
            search_query: '',
            loading:true,
            employeeExistEmail:'',
            employeesList: [],                
            internalEmployeeSearch: '',
            step1: true,
            checkEmployeeList: false,
            step2: false,
            step3: false,
            validation_err: 0,
            email_status:1,
            email_ckeck_flag: false,
            email_error_message: '',
            apires:false,
            emailStatus: false,
            emailStatusMessage: '',
            mailGunResult: false,
            mailGunError: '',
            employee: { 
              first_name:'',
              last_name:'',
              email:'',
              cell_phone:'', 
              client_id: ''  	
            },
          }
      },
      computed: {
        ...mapGetters({
            userToken: 'userToken',
            userRole: 'userRole',
            userClientID: 'userClientID',
        })
      },
      watch: {
          addEmployeesList: {
              handler(newAllOptions) {
                  this.filteredOptions = [...newAllOptions]
              },
              immediate: true
          }
      },
      methods: {
        validateEmail(input) {
            var validRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if (input.match(validRegex)) {
                return true;
            } else {
                this.emailStatus=false;
                this.emailStatusMessage='';
                return false;
            }
        },

        async checkMailWithMailgun(email) {
            if(this.validateEmail(email)) {
                await service.get('employee/validateEmail/'+email, {
                    'Authorization': this.userToken,
                }).
                then((res) => {
                    if(res.data.result == 'undeliverable'){
                        this.mailGunError = res.data.reason[0];
                        this.mailGunResult = false;
                    }else{
                        this.mailGunResult = true;
                    }                
                }).catch((err) => {
                    console.log(err);
                });
            }else {
                this.mailGunResult = false;
            }
        },

        async openStep3() {
            if(this.validateEmail(this.search_query)) {
                this.loading = true;
                await this.checkMailWithMailgun(this.search_query);
                this.loading = false;
                console.log(this.mailGunResult);
                if(this.mailGunResult){
                    this.step3 = true;                    
                    this.step2 = false;
                    this.step1 = false;
                    this.employee.email = this.search_query;
                }else {
                    this.$notify.error({
                        title: 'Email does not exist!',
                        message: this.mailGunError
                    });
                }
            }else {
                this.$notify.error({
                    title: 'Not a valid Email!',
                    message: 'Given email is not a Valid Email, please change the email'
                });
                return;
            }            
        },

        filterOptions(filterValue) {
            this.filteredOptions = this.addEmployeesList.filter(
                option => { 
                    if(option.email){
                        return option.email.includes(filterValue) || option.name.includes(filterValue)
                    } 
                    return option.name.includes(filterValue)
                }
            )
        },

        cancelAddEmployeeProcess() {
            this.employee.email = '';
            this.employeeExistEmail = '';
            this.internalEmployeeSearch = '';
            this.employeesList = [];
            this.checkEmployeeList= false;
            this.step1 = true;
            this.step2=false;
            this.step3=false;
        },

        addExternalEmployee() {
            this.selectedEmployeePattern = this.internalEmployeeSearch;
            this.searchExternalEmployees();
            this.checkEmployeeList= false;
            this.step1 = false;
            this.step2 = true;
        },

        searchExternalEmployees() {
            clearTimeout(timeout);
                timeout = setTimeout(() => {
                    if(this.search_query){
                        this.loading=true;
                        this.apires=false;
                        service.get('employee/getNonClientEmployees', {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'search':this.search_query,
                        }).
                        then((res) => {
                            this.addEmployeesList = res.data.result;
                            this.loading=false;
                            this.apires=true;
                        }).catch((err) => {
                            this.loading=false;
                            this.apires=true;                            
                        });
                    }
                }, 1000);
        },

        async getAllClientEmployees() {
            clearTimeout(this.timeout);
            this.$Progress.start();
            // this.loading = true;
            this.afterApi = false;
            this.employeesList=[];
            this.savedEmployees =[];
            var self = this;
            // this.timeout = setTimeout(async() => {
                await service.get('employee/getEmployeesByClient', {
                    'Authorization': self.userToken,
                    'cs3-context-role': self.userRole,
                    'cs3-context-clientId': self.userClientID,
                    'status': self.selectedStatusId,
                    'sort': self.selectedSortType,
                    'search': self.internalEmployeeSearch,
                }).then((res) => {
                    self.employeesList = res.data.result;
                    self.$Progress.finish();
                    // self.loading = false;
                    self.afterApi = true;
                }).catch((err) => {
                    console.log(err);
                    // self.loading = false;
                    self.afterApi = true;
                });
            // }, 500);
            this.checkEmployeeList = true;
        },

        checkEmail(){
          this.emailStatus = false;
          this.emailStatusMessage = '';
          if(this.validateEmail(this.employeeExistEmail)) {
            service.get('user/emailExists', {
                'Authorization': this.userToken,
                'email':this.employeeExistEmail,
            }).
            then((res) => {
            //    console.log("Email Status", res.data.result);
                if(res.data.result==0){
                    this.$notify({
                        title: this.$t('error'),
                        message: res.data.status_message,
                        type: 'error'
                    });
                    this.emailStatus = false;
                    this.emailStatusMessage=res.data.status_message
                    this.checkEmployeeList = true;
                }else{
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Your email address is not registered. Please register.',
                        type: 'success'
                    });
                    this.emailStatus = true;
                    this.emailStatusMessage=res.data.status_message;
                    this.employee.email = this.employeeExistEmail;
                    this.checkEmployeeList = true;
                }
                
            }).catch((err) => {
                console.log(err);
            });
          }else {
            this.$notify.error({
                message: "Please provide a valid email",
                title: 'Invalid Email'
            })
          }
        },

        addEmployee(employee){
            // this.loading=true;
            service.post('employee/createClientEmployeesAssociation', { 'userId':employee.id },
            {
                'Authorization': this.userToken,
                'cs3-context-role': this.userRole,
                'cs3-context-clientId': this.userClientID
            }).
            then((res) => {
                // console.log(res);
                this.$store.dispatch('selectEmployee', {
                    'id': res.data.result.id,
                    'name': employee.first_name+' '+employee.last_name,
                    'type': res.data.result.employable_type
                });
                this.$notify({
                    type: 'success',
                    title: 'Employee added successfully!',
                    message: 'Please add other details for the employee.'
                });
                this.$store.dispatch('setEditEmployeesFrom', 'editEmployeeList');
                this.$router.push({
                    'path': '/editEmployee/'+btoa(res.data.result.id)+'?tab=skill'
                });
            }).catch(err =>{
                this.$notify({
                    title: this.$t('error'),
                    message: 'Something went wrong please try again later.',
                    type: 'error'
                });
            })
        },

        submitNewEmployee(){
            this.$router.push({
                path: "/addEmployeeClient"
            });
        },

        async checkClientEmployeeList() {
            if(this.internalEmployeeSearch.length){
                await this.getAllClientEmployees();
            }else{
                this.employeesList = [];
            }
        },

        async checkClientEmployeeListOnClick() {
            this.loading = true;
            await this.checkClientEmployeeList();
            this.loading = false;
            if(this.validateEmail(this.internalEmployeeSearch) && this.employeesList.length){
                this.$notify.error({
                    message: "Email already exists and is associated to your account",
                    title: "Employee Exists!"
                });
            }else if(this.validateEmail(this.internalEmployeeSearch)&&!this.employeesList.length) {
                this.search_query = this.internalEmployeeSearch;
                this.addExternalEmployee();
            }else if(!this.validateEmail(this.internalEmployeeSearch)) {
                this.$notify.error({
                    message: "Please enter a valid email",
                    title: "Enter a valid email"
                });
            }

        },
          
        async saveNewEmployee(){
          if(this.validateEmail(this.employee.email)) {
            await service.get('user/emailExists', {
                'Authorization': this.userToken,
                'email':this.employee.email,
            }).
            then((res) => {
                if(res.data.result==0){
                    this.emailStatus = false;
                    this.email_error_message = res.data.status_message;
                    this.$notify.error({
                        message: this.email_error_message,
                        title: 'Email Already Registered!'
                    })
                    return;         
                }else{
                    this.emailStatus = true;
                }                
            }).catch((err) => {
                console.log(err);
            });
          }else {
            this.$notify.error({
                message: 'Please provide a valid Email.',
                title: 'Email Not Valid!'
            })
            return;
          }
              // this.checkCellPhone(this.employee.cell_phone);
          this.employee.client_id = this.userClientID;
          var cell_phone = '';
          if(this.employee.cell_phone=='' || this.employee.cell_phone=="") {
              this.$notify.error({
                  message: 'Phone number is Missing. Please add cell phone',
                  title: 'Check Required Fields!'
              })
              this.employee.cell_phone = '';
              return;
          }
          if(!this.email_status) {
              this.$notify.error({
                  message: this.email_error_message,
                  title: 'Email Already Registered!'
              })
              return;
          }else if(!this.validation_err) {
              this.$notify.error({
                  message: 'Please check required fields and phone number format',
                  title: 'Check Required Fields!'
              })
              return;
          }
          this.loading=true;
              
          await service.post('employee', this.employee, {
                'Authorization': this.userToken
            }).
            then((res) => {
            this.loading=false;
            // console.log(res.data.status_code);
            if(res.data.status_code&&res.data.status_code!="0"){
              this.$notify({
                type: 'success',
                title: 'Employee added successfully!',
                message: 'Please add other details for the employee.'
              });
              this.$router.push({
                    'path': '/editEmployee/'+btoa(res.data.result.id)+'?tab=skill'
                });
            }else if(res.data.status_code&&res.data.status_code=="0") {
                this.$message({
                    type: 'error',
                    message: res.data.status_message&&(typeof res.data.status_message)=='string'?res.data.status_message:res.data.status_message[0]
              });
            }else{
              this.$message({
                type: 'error',
                message: 'Sorry, Something went wrong: Please try again later.'
              });
            }
                  // this.$router.push({
                  //     path: `/clientEmployeesList`
                  // });
                  //console.log(res);
            }).catch((err) => {
                this.loading=false;
                this.$message({
                    type: 'error',
                    message: 'Sorry, Something Went Wrong: Please try again later.'
                });
            }); 	
        },

        blur(event) {
            if ($(event.target).val() === "") {
                $(event.target).siblings('.form-label').addClass('js-label-transition');
                this.validation_err = 0;
            } else {
                $(event.target).siblings('.form-label').removeClass('js-label-transition');
                this.validation_err = 1;
            }
        },

        blurCellPhone(event){
            let phone=$(event.target).val();
            let patt=/^\d{10,12}$/g;
            if(patt.test(phone) && phone != ""){
                $(event.target).siblings('.form-label').removeClass('js-label-transition');
                this.validation_err = 0;
            }else{
                $(event.target).siblings('.form-label').addClass('js-label-transition');
                this.validation_err = 1;
            }
            this.$validator.validateAll().then((result)=>{
                if(result)
                    this.validation_err = 1;
                else
                    this.validation_err = 0;
            });
        },

        checkCellPhone(phone){
            let pat=/^\d{10,12}$/g;
            if(pat.test(phone) && phone != ""){
                this.validation_err = 0;
            }else{
                this.validation_err = 1;
            }
            this.$validator.validateAll().then((result)=>{
                if(result)
                    this.validation_err = 1;
                else
                    this.validation_err = 0;
            });
        },
        
        emailExists(){
            this.email_error_message = '';
            this.email_ckeck_flag=true;
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                service.get('user/emailExists', {
                    'Authorization': this.userToken,
                    'email':this.employee.email,
                }).
                then((res) => {
                    this.email_ckeck_flag=false;
                    // console.log("Email Status", res.data.result);
                    this.email_status=res.data.result;
                    this.email_error_message = res.data.status_message
                    console.log(this.email_status);
                    // return res.data.result
                }).catch((err) => {
                    this.email_ckeck_flag=false;
                    console.log(err);
                    // return 0;
                });
            }, 1000);
        },
      },
      mounted() {
        document.getElementById('employee-search-input').focus();
      },
      created() {
          this.loading=false;
        //   employee-search-inpu
          // this.getAllClientEmployees();
      }
   }

</script>
<style scoped>

.email-status-success {
    color: #06aa00;
    font-weight: bold;
    padding: 0;
    height: 20px;
}
.email-status-error {
    color: #dd3000;
    font-weight: bold;
    padding: 0;
    height: 20px;
}
.pl-20{
    padding-left: 20px;
}
.pb-6{
    padding-bottom: 6px;
}
.custom-list-search-background {
    background-color: #f4f7f8;
    padding: 5px;
    border-radius: 6px;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
}

.custom-list-search{
    margin: 5px;
    padding: 5px;
    border-bottom: 1px solid #afacac;
    word-break: break-all;
}
.el-select-dropdown__item{
    padding-right: 40px;
}
.mt-15 {
    margin-top: 15px;
}
.el-input__inner {
    /* display: none; */
    height: auto !important
}
.line-break-between-section{
    margin-top: 50px;
}
.notic-ul-item{
    border-radius: 6px;
    background-color: #e4d8d8;
    padding: 10px;
}
.notic-li-item{
    padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/employees/addEmployeeNewFlow.vue